import React, { useContext, useEffect, useState } from 'react';
import Footer from '../components/footer';
import { createGlobalStyle } from 'styled-components';
import Pagination from "../components/Pagination";
import { ethers } from "ethers";
import Moment from 'react-moment';
import { getUserTransactions } from '../../api/api';
const GlobalStyles = createGlobalStyle`
header#myHeader .logo .d-block{
  display: none !important;
}
header#myHeader .logo .d-none{
  display: block !important;
}
.navbar .mainside a{
  background: #8364e2;
  &:hover{
    box-shadow: 2px 2px 20px 0px #8364e2;
  }
}
.item-dropdown{
  .dropdown{
    a{
      &:hover{
        background: #8364e2;
      }
    }
  }
}
.btn-main{
  background: #8364e2;
  &:hover{
    box-shadow: 2px 2px 20px 0px #8364e2;
  }
}
p.lead{
  color: #a2a2a2;
}
.navbar .navbar-item .lines{
  border-bottom: 2px solid #8364e2;
}
.jumbotron.no-bg{
  height: 100vh;
  overflow: hidden;
  background-repeat: repeat;
  background-size: cover;
  background-position: bottom;
  background-repeat: no-repeat;
}
#tsparticles{
  top: 0;
}
.text-uppercase.color{
  color: #8364e2;
}
.de_count h3 {
  font-size: 36px;
  margin-bottom: 0px;
}
.de_count h5{
  font-size: 14px;
  font-weight: 500;
}
h2 {
  font-size: 30px;
}
.box-url{
  text-align: center;
  h4{
    font-size: 16px;
  }
}
.de_countdown{
  border: solid 2px #8364e2;
}
.author_list_pp, .author_list_pp i, 
.nft_coll_pp i, .feature-box.style-3 i, 
footer.footer-light #form_subscribe #btn-subscribe i, 
#scroll-to-top div{
  background: #8364e2;
}
footer.footer-light .subfooter .social-icons span i{
  background: #403f83;
}
.author_list_pp:hover img{
  box-shadow: 0px 0px 0px 2px #8364e2;
}
.nft__item_action span{
  color: #8364e2;
}
.feature-box.style-3 i.wm{
  color: rgba(131,100,226, .1);
}
@media only screen and (max-width: 1199px) {
  .navbar{
    
  }
  .navbar .menu-line, .navbar .menu-line1, .navbar .menu-line2{
    background: #fff;
  }
  .item-dropdown .dropdown a{
    color: #fff !important;
  }
}
.profileBtn{
  width:150px;
  text-align: center;
  margin-top:5px;
}
.fsize32{
  font-size: 42px;
}
.text-left{
  text-align: left;
}
.exemplar_avatar {
  display: flex;
}
`;

const Transactions = function () {

  const [openMenu, setOpenMenu] = React.useState(true);
  const [openMenu1, setOpenMenu1] = React.useState(false);
  const [openMenu2, setOpenMenu2] = React.useState(false);
  const [openMenu3, setOpenMenu3] = React.useState(false);
  const [openMenu4, setOpenMenu4] = React.useState(false);
  const handleBtnClick = () => {
    setOpenMenu(!openMenu);
    setOpenMenu1(false);
    setOpenMenu2(false);
    setOpenMenu3(false);
    setOpenMenu4(false);
    document.getElementById("follow").classList.remove("active");
    document.getElementById("sale").classList.remove("active");
    document.getElementById("offer").classList.remove("active");
    document.getElementById("like").classList.remove("active");
  };
  const handleBtnClick1 = () => {
    setOpenMenu1(!openMenu1);
    setOpenMenu2(false);
    setOpenMenu(false);
    setOpenMenu3(false);
    setOpenMenu4(false);
    document.getElementById("follow").classList.add("active");
    document.getElementById("sale").classList.remove("active");
    document.getElementById("offer").classList.remove("active");
    document.getElementById("like").classList.remove("active");
  };
  const handleBtnClick2 = () => {
    setOpenMenu2(!openMenu2);
    setOpenMenu(false);
    setOpenMenu1(false);
    setOpenMenu3(false);
    setOpenMenu4(false);
    document.getElementById("follow").classList.remove("active");
    document.getElementById("sale").classList.add("active");
    document.getElementById("offer").classList.remove("active");
    document.getElementById("like").classList.remove("active");
  };
  const handleBtnClick3 = () => {
    setOpenMenu3(!openMenu3);
    setOpenMenu(false);
    setOpenMenu1(false);
    setOpenMenu2(false);
    setOpenMenu4(false);
    document.getElementById("follow").classList.remove("active");
    document.getElementById("sale").classList.remove("active");
    document.getElementById("offer").classList.remove("active");
    document.getElementById("like").classList.add("active");
  };
  const handleBtnClick4 = () => {
    setOpenMenu4(!openMenu4);
    setOpenMenu(false);
    setOpenMenu1(false);
    setOpenMenu3(false);
    setOpenMenu2(false);
    document.getElementById("follow").classList.remove("active");
    document.getElementById("sale").classList.remove("active");
    document.getElementById("offer").classList.add("active");
    document.getElementById("like").classList.remove("active");
  };
  ///////////////
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [items, setItems] = useState([]);
  const getItems = async () => {
    let res = await getUserTransactions(currentPage);
    setItems(res.data);
    setTotalRecords(res.totalRecords)
  }


  useEffect(() => {
    getItems();

  }, [currentPage])
  const onPageChange = async (page) => {
    setCurrentPage(page)
  }
  ///////////////
  const shortener = (txt) => {
    return txt.toString().substring(0, 8) + "..." + txt.toString().substring(txt.toString().length - 6)
  }
  const amountFormatter = (amount) => {
    if (!amount) {
      return "0.0"
    }
    return ethers.utils.formatEther(amount)
  }
  const getName = (type) => {
    switch (type) {
      //Depositor Contract
      case "DEPOSIT_FOR_MINT": return "DEPOSIT FOR MINT";
      case "WITHDRAW_FUNDS_DEPOSITOR": return "WITHDRAW ROYALTY CLUSTER A";
      case "CLAIMING_A": return "CLAIM NFT ROYALTY CLUSTER A";
      //Minter Contract
      case "MARKETPLACE_APPROVE": return "MARKETPLACE APPROVE";
      //Central Contract
      case "SALE": return "NTF ON SALE";
      case "CHANGE_PRICE": return "NFT PRICE UPDATE";
      case "CANCEL_SALE": return "REMOVE NTF FROM SALE";
      case "BUY": return "BUY NFT";
      case "WITHDRAW_FUNDS_CENTRAL": return "WITHDRAW ROYALTY CLUSTER B";
      case "CLAIMING_B": return "CLAIM NFT ROYALTY CLUSTER B";
      //Signer Contract
      case "SIGN_OFFER": return "AUTOGRAPH REQUEST";
      case "SIGN_OFFER_WITHDRAW": return "CANCEL AUTOGRAPH REQUEST";
      case "SIGN_OFFER_ACCEPT": return "ACCEPT AUTOGRAPH";
      case "WITHDRAW_FUNDS_SIGNER": return "WITHDRAW ROYALTY CLUSTER C";
      case "CLAIMING_C": return "CLAIM NFT ROYALTY CLUSTER C";
      case "AUTOGRAPH_PRICE_CHANGE": return "AUTOGRAPH PRICE CHANGE";
      //Autograph Contract
      case "AUTOGRAPH_SLOT": return "SET AUTOGRAPH";

    }
  }
  return (
    <div>
      <GlobalStyles />

      <section className=' breadcumb no-bg'>
        <div className='mainbreadcumb'>
          <div className='container'>
            <div className='row m-10-hor'>
              <div className='col-12'>
                <h1 className='text-center'>Transactions</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='container no-top'>

        <div className='container'>
          <div className="spacer-double"></div>
          <table className="table de-table table-rank">
            <thead>
              <tr>
                <th scope="col">Date</th>
                <th scope="col">Type</th>
                <th scope="col">TxHash</th>
                <th scope="col">Status</th>
              </tr>
              <tr></tr>
            </thead>
            <tbody>
              {items && items.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>
                      <span className="color-grey fontsize12">
                        {(item.createdAt || item.updatedAt) && <Moment format="HH:mm DD MMMM YYYY">
                          {item.updatedAt || item.createdAt}
                        </Moment>}
                      </span>
                    </td>
                    <td className="fontsize12">{getName(item.type)}</td>
                    <td>{item.txHash && <><a className=' color' href={('https://moonbeam.moonscan.io/tx/') + (item.txHash)} target="_blank"><span >{shortener(item.txHash)}  <span className="fa fa-link "></span></span></a></>}</td>
                    <td className="fontsize12">
                      {item && item.status === 0 && <div className="statusLabel-yellow">PENDING</div>}
                      {item && item.status === 2 && <div className="statusLabel-green">SUCCESS</div>}
                      {item && item.status === 3 && <div className="statusLabel-red">FAILED</div>}
                    </td>
                  </tr>
                )
              })}


            </tbody>
          </table>

        </div>
      </section>
      <section className="container no-top">
        <div ><Pagination onPageChange={onPageChange} _currentPage={currentPage} recordsPerPage={10} pageNumberLimit={5} totalRecords={totalRecords} /></div>
      </section>
      <Footer />
    </div>

  );
}

export default Transactions;